var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7437 10.7437 0 24 0C37.2562 0 48 10.7437 48 24C48 37.2562 37.2562 48 24 48C10.7437 48 0 37.2562 0 24ZM34.8562 19.8563C35.8781 18.8344 35.8781 17.1656 34.8562 16.1437C33.8344 15.1219 32.1656 15.1219 31.1437 16.1437L21 26.2875L16.8563 22.1437C15.8344 21.1219 14.1656 21.1219 13.1437 22.1437C12.1219 23.1656 12.1219 24.8344 13.1437 25.8562L19.1437 31.8562C20.1656 32.8781 21.8344 32.8781 22.8562 31.8562L34.8562 19.8563Z",
    fill: "#008018"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.b58484d4816bb09b325c185c619adaad.svg";
export { ForwardRef as ReactComponent };